// extracted by mini-css-extract-plugin
export var activeStep = "solutions_index-module--active-step--G0EUY";
export var appSlider = "solutions_index-module--app-slider--3oGkh";
export var content = "solutions_index-module--content--3VFwH";
export var contentWrapper = "solutions_index-module--content-wrapper--2tOdA";
export var defaultContainer = "solutions_index-module--default-container--MmxQv";
export var dot = "solutions_index-module--dot--3l5La";
export var featureSlider = "solutions_index-module--feature-slider--D5Q9v";
export var innerPagesSlider = "solutions_index-module--inner-pages-slider--3Z7mg";
export var leftAppSlide = "solutions_index-module--left-app-slide--3Ffkf";
export var link = "solutions_index-module--link--2-i_R";
export var list = "solutions_index-module--list--3aymE";
export var logoSlider = "solutions_index-module--logo-slider--24y7p";
export var numbers = "solutions_index-module--numbers--2bTVO";
export var phoneAppSelect = "solutions_index-module--phone-app-select--2pS53";
export var phoneCaseSelect = "solutions_index-module--phone-case-select--19ffl";
export var process = "solutions_index-module--process--26FVx";
export var processContainer = "solutions_index-module--process-container--rrZaZ";
export var processText = "solutions_index-module--process-text--3KOd4";
export var processTitle = "solutions_index-module--process-title--IWCYl";
export var rightAppSlide = "solutions_index-module--right-app-slide--1Aw-Z";
export var slickActive = "solutions_index-module--slick-active--oxMgn";
export var slickArrow = "solutions_index-module--slick-arrow--3H9W_";
export var slickCenter = "solutions_index-module--slick-center--1Q213";
export var slickDots = "solutions_index-module--slick-dots--1fRp-";
export var slickNext = "solutions_index-module--slick-next--13op2";
export var slickPrev = "solutions_index-module--slick-prev--1XA_G";
export var slickSlide = "solutions_index-module--slick-slide--86OwF";
export var slickSlider = "solutions_index-module--slick-slider--YHvR7";
export var slickTrack = "solutions_index-module--slick-track--hiheq";
export var solutions = "solutions_index-module--solutions--3KTky";
export var solutionsContainer = "solutions_index-module--solutions-container--2-rJ-";
export var solutionsWrapper = "solutions_index-module--solutions-wrapper--3cfPs";
export var solvingSlider = "solutions_index-module--solving-slider--30bp5";
export var steps = "solutions_index-module--steps--HvJBR";
export var titleWrapper = "solutions_index-module--title-wrapper--2P09o";